"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHeaderJustify = exports.getCellAlignment = void 0;
var lodash_1 = require("lodash");
var DATATYPE_TO_ALIGNMENT = {
    string: 'left',
    number: 'right',
    boolean: 'center',
    date: 'right',
};
var ALIGNMENT_TO_JUSTIFY = {
    left: 'flex-start',
    right: 'flex-end',
    center: 'center',
};
function getCellAlignment(dataType) {
    if (dataType === void 0) { dataType = 'string'; }
    return lodash_1.get(DATATYPE_TO_ALIGNMENT, dataType, 'left');
}
exports.getCellAlignment = getCellAlignment;
function getHeaderJustify(cellAlignment) {
    if (cellAlignment === void 0) { cellAlignment = 'center'; }
    return lodash_1.get(ALIGNMENT_TO_JUSTIFY, cellAlignment, 'flex-start');
}
exports.getHeaderJustify = getHeaderJustify;
